import { render, staticRenderFns } from "./PuntosGestionEdit.vue?vue&type=template&id=1dfaf8a4"
import script from "./PuntosGestionEdit.vue?vue&type=script&lang=js"
export * from "./PuntosGestionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports